import * as api from "../api";
import * as actionsType from "./actionsType";
import { errorHandler } from "./general";

export const getBrands = (formData, history) => async (dispatch) => {
  try {
    dispatch({
      type: actionsType.GET_BRANDS,
      payload: null,
    });
    dispatch({
      type: actionsType.SET_LOADING,
      payload: true,
    });
    const { data } = await api.getBrands(formData);
    dispatch({ type: actionsType.GET_BRANDS, payload: data });
    dispatch(getAllCategories(history));
    dispatch({
      type: actionsType.SET_LOADING,
      payload: false,
    });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const deleteBrand =
  (idsArray, formData, history) => async (dispatch) => {
    try {
      dispatch({
        type: actionsType.SET_LOADING,
        payload: true,
      });
      await api.deleteBrand({ ids: idsArray });
      dispatch(getBrands(formData, history));
      dispatch({
        type: actionsType.SET_LOADING,
        payload: false,
      });
      dispatch({
        type: actionsType.SET_MESSAGE,
        payload: { type: "success", text: "Brand deleted Successfully" },
      });
    } catch (error) {
      dispatch(errorHandler(error, history));
    }
  };

export const getAllCategories = (history) => async (dispatch) => {
  try {
    dispatch({
      type: actionsType.GET_BRANDS_CATEGORIES,
      payload: null,
    });
    dispatch({
      type: actionsType.SET_LOADING,
      payload: true,
    });
    const { data } = await api.getAllCategories();
    dispatch({
      type: actionsType.SET_LOADING,
      payload: false,
    });
    dispatch({
      type: actionsType.GET_BRANDS_CATEGORIES,
      payload: data,
    });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const createBrand = (newData, formData, history) => async (dispatch) => {
  try {
    dispatch({
      type: actionsType.SET_LOADING,
      payload: true,
    });
    await api.createBrand(newData);
    dispatch(getBrands(formData, history));
    dispatch({
      type: actionsType.SET_MESSAGE,
      payload: {
        type: "success",
        text: "New Brand has been created successfully",
      },
    });
    dispatch({
      type: actionsType.SET_LOADING,
      payload: false,
    });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};

export const updateBrand = (newData, formData, history) => async (dispatch) => {
  try {
    dispatch({
      type: actionsType.SET_LOADING,
      payload: true,
    });
    await api.updateBrand(newData);
    dispatch(getBrands(formData, history));
    dispatch({
      type: actionsType.SET_MESSAGE,
      payload: {
        type: "success",
        text: "Brand has been updated successfully",
      },
    });
    dispatch({
      type: actionsType.SET_LOADING,
      payload: false,
    });
  } catch (error) {
    dispatch(errorHandler(error, history));
  }
};
